import { render, staticRenderFns } from "./JWL_Programme.vue?vue&type=template&id=0ef9e7a1&"
import script from "./JWL_Programme.vue?vue&type=script&lang=ts&"
export * from "./JWL_Programme.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports